var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-blue-700 rounded-full cursor-pointer mr-1",on:{"click":function($event){return _vm.$emit('click')}}},[_c('unicon',{attrs:{"name":"times","fill":"white"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }